"use client";

import { useState } from "react";
import Link from "next/link";
import Image from "next/image";
import { IconSearch } from "@tabler/icons-react";
import Navbar from "../../components/atlas/Navbar";
import Footer from "../../components/atlas/Footer";
import styles from "./page.module.css";

const APPS = [
  {
    slug: "thoracic-aorta",
    title: "Thoracic Aorta",
    link: "https://atlas.sissa.it/thoracic_aorta/",
    image: "/thoracic_aorta.png",
    description:
      "The thoracic aortic aneurysm is a permanent dilation in the ascending thoracic part that can cause severe bleeding that can lead to dissection or even rupture/burst of the aneurysm.",
  },
  {
    slug: "aorto-femoral",
    title: "Aorto-Femoral",
    link: "https://atlas.sissa.it/aorto_femoral/",
    image: "/aorto_femoral.png",
    description:
      "The aortic model extends from the supraceliac aorta to the femoral and femoris artery bifurcation. The data was developed on SimVascular",
  },
  {
    slug: "carotid-artery",
    title: "Carotid Artery",
    link: "https://atlas.sissa.it/carotid_artery/",
    image: "/carotid_artery.png",
    description:
      "The Carotid Artery is one of the largest arterial trunks in the human body. Together with the vertebral artery, the carotid arises the central system and its facial structures.",
  },
  {
    slug: "coronary",
    title: "Coronary",
    link: "https://atlas.sissa.it/coronary/",
    image: "/coronary.png",
    description:
      "Coronary arteries are blood vessels located on the surface of the heart and oxygenate muscle tissue in order to support its functioning.",
  },
   {
    slug: "bypass-flow",
    title: "Bypass Flow",
    link: "https://atlas.sissa.it/bypassflow/",
    image: "/bypass_flow.png",
    description:
      "Bypass flow simulation to study hemodynamics in vascular grafts.",
  },
  {
    slug: "left-atrium-appendage-simulator",
    title: "Left Atrium Appendage Simulator",
    link: "https://atlas.sissa.it/left_atrium_appendage/",
    image: "/left_atrium_appendage_simulator.png",
    description:
      "Reduced-order simulations of left atrial appendage flow highlight blood stasis patterns in a patient with atrial fibrillation.",
  },
  {
    slug: "coronary-bypass-graft",
    title: "Coronary Bypass Graft",
    link: "https://atlas.fastcomputing.net/coronary_stenosis/",
    image: "/coronary_bypass_graft.png",
    description:
      "This application simulates blood flow dynamics via Reduced Order Models (ROMs) within a patient-specific coronary bypass following an isolated 70% stenosis of the Left Main Coronary Artery (LMCA) grafted with the Left Internal Thoracic Artery (LITA). ",
  }
];

/** Pagina con la griglia delle applicazioni disponibili, filtrabile per testo. */
export default function ApplicationsPage() {
  const [search, setSearch] = useState("");

  const filtered = APPS.filter(
    (a) =>
      a.title.toLowerCase().includes(search.toLowerCase()) ||
      a.description.toLowerCase().includes(search.toLowerCase()),
  );

  return (
    <>
      <Navbar />

      <main className={styles.applicationsPage}>
        <h1 className={styles.applicationsTitle}>Applications</h1>

        <div className={styles.applicationsNotices}>
          <p className={styles.applicationsNoticeLine}>
            If you want to use these apps you need to register, please{" "}
            <Link href="/account/signup">click here</Link> and save the
            password.
          </p>
          <p className={styles.applicationsNoticeLine}>
            If you already have an account,{" "}
            <Link href="/account/forgot-password">click here</Link> to
            recover the password.
          </p>
        </div>

        <div className={styles.searchWrap}>
          <span className={styles.searchIcon}>
            <IconSearch size={15} />
          </span>
          <input
            type="text"
            className={styles.searchInput}
            placeholder="Search..."
            autoComplete="off"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>

        {filtered.length > 0 ? (
          <div className={styles.appsGrid}>
            {filtered.map((app) => (
              <Link key={app.slug} href={app.link} className={styles.appCard}>
                <div className={styles.appCardMedia}>
                  <Image
                    src={app.image}
                    alt={app.title}
                    width={2000}
                    height={2000}
                  />

                  <div className={styles.appCardOverlay}>
                    <div className={styles.appCardOverlayLogo}>
                      <Image
                        src="/fast_logo_orange.png"
                        alt="Fast Computing"
                        width={72}
                        height={72}
                      />
                    </div>
                  </div>
                </div>
                <div className={styles.appCardBody}>
                  <div className={styles.appCardTitle}>{app.title}</div>
                  <p className={styles.appCardDesc}>{app.description}</p>
                </div>
              </Link>
            ))}
          </div>
        ) : (
          <p className={styles.noResults}>No applications match your search.</p>
        )}
      </main>

      <Footer />
    </>
  );
}
